<template>
  <b-form
    novalidate
    autocomplete="off"
    class="login-form"
    @submit.prevent="onSubmit()"
  >
    <b-form-group
      class="login-form__wrapper"
    >
      <label
        class="login-form__label"
        v-html="$t(title)"
      />
      <form-input
        id="username"
        ref="username"
        :label="$t('label.email')"
        :placeholder="$t('placeholder.enter_email')"
        class="login-form__form-input"
        variant="minimal"
        required
        type="email"
        data-testing="input_username"
      />
      <form-input
        id="password"
        ref="password"
        :label="$t('label.password')"
        :placeholder="$t('placeholder.enter_password')"
        type="password"
        variant="minimal"
        required
        class="login-form__form-input"
        show-password-icon
        data-testing="input_password"
      />
      <div
        v-if="externalError !== null"
        class="invalid-feedback-box"
        v-html="$t('validation.messages.' + externalError.msg)"
      />
      <btn
        variant="primary"
        class="login-form__btn"
        type="submit"
        data-testing="button_submit"
        v-html="$t('label.signin')"
      />
      <router-link
        to="password-forgotten"
        class="login-form__link"
        v-text="$t('button.password_forgotten')"
      />
    </b-form-group>
  </b-form>
</template>

<script>
import { BForm } from 'bootstrap-vue';
import { BFormGroup } from 'bootstrap-vue';
import Notification from '@components/Notification/Notification';
import FormInput from '@components/FormInput/FormInput';
import Btn from '@components/Btn/Btn';

/**
 * Standard login form
 */
export default {
  name: 'LoginForm',
  components: {
    BForm,
    BFormGroup,
    Notification,
    FormInput,
    Btn
  },
  inject: {
    $validator: '$validator',
  },
  props: {
    title: {
      type: String,
      default: 'label.login'
    },
    externalError: {
      type: Object,
      default: null
    }
  },
  methods: {
    /**
     * Dispatches the login action
     * @event onSubmit
     * @type {Submit}
     */
    onSubmit() {
      this.$validator.validateAll().then(result => {
        if (!result) return;

        this.$store.dispatch('user/postLogin', {
          email: this.$refs.username.model,
          password: this.$refs.password.model
        }).then(result => { // This is a fallback, if the login is called and the user is already logged in
          this.$store.dispatch('user/getUser').then(() => {
            this.$store.dispatch('guarantee/create/setUserCred');
            this.$user.setPermissions(this.$store.getters['user/getPermissions']);
          });
        });

        this.errors.clear();
        return;
      });
    }
  }
};
</script>

<style lang="scss">
  @import './LoginForm';
</style>
